var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "e4b593895e9d5ef6f002cb4f72f8a2d7889f1ac9"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["icloudready-newwebsite@icloudready"] = {
  id: "e4b593895e9d5ef6f002cb4f72f8a2d7889f1ac9"
};